import { useState, FormEvent } from "react";

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const message = (form.elements.namedItem("message") as HTMLTextAreaElement).value;
    if (message.length > 500) return;

    setSubmitting(true);
    const formData = new FormData(form);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });
    try {
            const res = await fetch("https://ultimateheatingcooling-contact.connortuttle642.workers.dev", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (res.ok) {
        setSubmitted(true);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20 bg-[#0B2447]">
      <div className="max-w-6xl mx-auto px-5 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {/* Info */}
          <div>
            <span className="text-[#C8102E] text-xs font-bold tracking-[0.2em] uppercase">CONTACT US</span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-white mt-3 mb-4 md:mb-5 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Ready to Schedule Service?
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-8 md:mb-10">
              Whether you need a quick repair, a full system replacement, or just want a second opinion — our team is ready. Most requests are answered within a few hours.
            </p>

            <div className="space-y-5 md:space-y-6">
              {[
                { icon: "ri-phone-fill", label: "Phone", value: "(959) 241-8524", href: "tel:9592418524" },
                { icon: "ri-map-pin-2-line", label: "Service area", value: "New London County, Tolland County, Hartford County", href: "#" },
                { icon: "ri-time-line", label: "Hours", value: "Mon–Fri 7am–6pm", href: "#" },
                { icon: "ri-mail-send-line", label: "Email", value: "ultimateheatingandcoolingllc@gmail.com", href: "mailto:ultimateheatingandcoolingllc@gmail.com" },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-3 md:gap-4">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-[#C8102E]/15 rounded-xl flex-shrink-0">
                    <i className={`${item.icon} text-[#C8102E] text-base md:text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-0.5">{item.label}</p>
                    <a href={item.href} className="text-sm text-gray-200 hover:text-[#C8102E] transition-colors cursor-pointer leading-relaxed">
                      {item.value}
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {/* Google Maps Embed */}
            <div className="mt-8 rounded-xl overflow-hidden border-4 border-[#C8102E]" style={{ height: "220px" }}>
              <iframe
                title="Ultimate Heating & Cooling Mechanical LLC - Somers, CT"
                src="https://maps.google.com/maps?q=41.9926,-72.4476&z=13&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl p-6 md:p-8">
            {submitted ? (
              <div className="flex flex-col items-center justify-center h-full text-center py-14">
                <div className="w-14 h-14 flex items-center justify-center bg-[#C8102E]/10 rounded-full mb-5">
                  <i className="ri-check-line text-[#C8102E] text-3xl"></i>
                </div>
                <h3 className="text-lg font-extrabold text-[#0B2447] mb-2">Request Received!</h3>
                <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
                  We&apos;ll reach out within 1–2 business hours. For emergencies, call us directly.
                </p>
                <a href="tel:9592418524" className="mt-4 text-[#C8102E] font-bold text-sm hover:underline cursor-pointer">
                  (959)241-8524
                </a>
              </div>
            ) : (
              <form
                id="contact-us-form"
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <h3 className="text-lg font-extrabold text-[#0B2447] mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Request a Free Quote
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">First Name</label>
                    <input
                      type="text"
                      name="first_name"
                      required
                      placeholder="John"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-[#C8102E] transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Last Name</label>
                    <input
                      type="text"
                      name="last_name"
                      required
                      placeholder="Doe"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-[#C8102E] transition-colors"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="john@example.com"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-[#C8102E] transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="203-555-0100"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-[#C8102E] transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Service Needed</label>
                  <select
                    name="service"
                    required
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-[#C8102E] transition-colors bg-white cursor-pointer"
                  >
                    <option value="">Select a service...</option>
                    <option value="Heating Repair">Heating Repair</option>
                    <option value="Furnace Replacement">Furnace Replacement</option>
                    <option value="AC Repair">AC Repair</option>
                    <option value="AC Installation">AC Installation</option>
                    <option value="Heat Pump Install">Heat Pump Install</option>
                    <option value="Indoor Air Quality">Indoor Air Quality</option>
                    <option value="Annual Tune-Up">Annual Tune-Up</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                    Message <span className="text-gray-400 font-normal">({charCount}/500)</span>
                  </label>
                  <textarea
                    name="message"
                    rows={3}
                    maxLength={500}
                    placeholder="Tell us about your heating or cooling issue..."
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-[#C8102E] transition-colors resize-none"
                  />
                  {charCount > 500 && (
                    <p className="text-red-500 text-xs mt-1">Message must be 500 characters or less.</p>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={submitting || charCount > 500}
                  className="w-full bg-[#C8102E] text-white font-bold text-sm py-3 rounded-full hover:bg-[#A8091D] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {submitting ? "SENDING..." : "GET MY FREE QUOTE"}
                </button>
                <p className="text-xs text-gray-400 text-center">We respond within 1–2 business hours</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

